<template>
  <div>
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>

    

    <div class="product_details">
      <!-- 标题 -->
      <div class="product_name">
        {{ detailsInfo[`${currentLang.prefix}no`]
        }}{{ detailsInfo[`${currentLang.prefix}title`] }}
      </div>
      <!-- 内容 -->
      <div
        class="product_content"
        v-html="detailsInfo[`${currentLang.prefix}content`]"
      ></div>
      <!-- 产品图片 -->
      <div class="product_img">
        <div class="product_small_img_wrap">
          <div
            :class="[
              'product_small_img',
              chooseIndex === index ? 'chooseImg' : '',
            ]"
            v-for="(item, index) in pictureList"
            :key="index"
            @click="changePicture(index)"
          >
            <img :src="item" alt="" />
          </div>
        </div>
        <img class="product_big_img" :src="pictureList[chooseIndex]" alt="" />
      </div>
      <!-- 规格信息 -->
      <div class="ggxh_wrap">
        <div class="ggxh_name">{{ productDetail.label1 }}</div>
        <div class="ggxh_list" v-for="(item, index) in gzxhList" :key="index">
          <div class="left_wrap">{{ item.title }}</div>
          <div class="right_wrap">{{ item.value }}</div>
        </div>
      </div>
      <!-- 综合信息 -->
      <div class="ggxh_wrap">
        <div class="ggxh_name">{{ productDetail.label2 }}</div>
        <div class="zh_list">
          <div class="zh_left">{{ productDetail.label3 }}</div>
          <div
            class="zh_right"
            v-html="detailsInfo[`${currentLang.prefix}summary`]"
          ></div>
        </div>
        <div class="zh_list">
          <div class="zh_left">{{ productDetail.label4 }}</div>
          <div
            class="zh_right"
            v-html="detailsInfo[`${currentLang.prefix}cpys`]"
          ></div>
        </div>
        <div class="zh_list">
          <div class="zh_left">{{ productDetail.label5 }}</div>
          <div
            class="zh_right"
            v-html="detailsInfo[`${currentLang.prefix}jgtd`]"
          ></div>
        </div>
        <div class="zh_list">
          <div class="zh_left">{{ productDetail.label6 }}</div>
          <div class="zh_right pdf_wrap" v-if="detailsInfo.files_name !== ''">
            <img src="../../../assets/images/public/pdf.png" alt="" />
            <span @click="downloadPDF">{{ detailsInfo.files_name }}</span>
          </div>
        </div>
      </div>
      <div class="ggxh_wrap2">
        <div class="ggxh_name_wrap">
          <span
            :class="[glChoose === 1 ? 'ggxh_glzxq' : 'ggxh_glgxf']"
            @click="changeTab(1)"
            >{{ productDetail.label7 }}</span
          >
          <span
            :class="[glChoose === 2 ? 'ggxh_glzxq' : 'ggxh_glgxf']"
            @click="changeTab(2)"
            >{{ productDetail.label8 }}</span
          >
        </div>
        <div class="ggxh_name_title">
          <template v-if="glChoose === 1">
            <span 
            >{{ detailsInfo[`${currentLang.prefix}no`] }}-{{
              detailsInfo[`${currentLang.prefix}title`]
            }}，</span
          >{{ productDetail.label9 }}
          </template>
          <template v-else>
            <span 
            >{{ detailsInfo[`${currentLang.prefix}no`] }}-{{
              detailsInfo[`${currentLang.prefix}title`]
            }}，</span
          >{{ productDetail.label10 }}
          </template>
          
        </div>
        <div class="ggxh_list_wrap">
          <el-collapse accordion>
            <el-collapse-item v-for="(item, index) in productList" :key="index">
              <template slot="title">
                <span></span>
                {{ item[`${currentLang.prefix}no`] }}-{{
                  item[`${currentLang.prefix}title`]
                }}
              </template>
              <div class="product_detsils">
                <div class="product_left_details">
                  <div class="product_left_details_title">
                    {{ productDetail.label3 }}
                  </div>
                  <div
                    class="product_info"
                    v-html="item[`${currentLang.prefix}summary`]"
                  ></div>
                </div>
                <div class="product_right_img">
                  <img :src="item.full_image" alt="" />
                  <div class="dynamic_btn" @click="changeProduct(item)">
                    <i class="el-icon-right"></i>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        
        <!-- 返回按钮 -->
        <div style="margin:30px 0;display:flex;justify-content:flex-end;border-bottom:1px solid #ccc;">
          <back-button>
            <i slot="prefixIcon"></i>
            返回上一级
            <i slot="suffixIcon" class="el-icon-arrow-right"></i>
          </back-button>
        </div>
      </div>
    </div>
    <footer-wrap></footer-wrap>

    <feedback-popup></feedback-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getCateDetailInfo, getProductInfo } from "@/utils/http.js";
import FeedbackPopup from './modules/feedbackPopup.vue';

export default {
  components: {
    FeedbackPopup
  },

  data() {
    return {
    
      detailsInfo: {},
      gzxhList: [],
      pictureList: [],
      chooseIndex: 0,
      glChoose: 1,
      productList: [],
    };
  },

  computed: {
    ...mapGetters(["currentLang"]),
    productDetail() {
      return this.currentLang.config.productCenterPage.productDetail;
    },
  },

  created() {
    this.fetchProductDetail()
    this.getDetails()
  },

  methods: {
    getDetails() {
      getCateDetailInfo({
        cate_id: this.$route.query.id,
        sonId: this.$route.query.sonId,
      }).then((res) => {
        if (res.code === 1) {
          return
          this.gzxhList = [];
          this.pictureList = [];
          this.productInfo = res.data
          this.productList = res.data.glzxq;
          res.data.product_list.forEach((item) => {
            if (this.$route.query.sonId === item.id + "") {
              this.detailsInfo = item;
              this.pictureList = item.full_image
                .split(",")
                .concat(item.full_images.split(","));
              let json = {};
              json = JSON.parse(item[`${this.currentLang.prefix}gzxh_json`]);
              for (var i in json) {
                this.gzxhList.push({ title: i, value: json[i] });
              }
            }
          });
        }
      });
    },
    
    // 获取产品详情
    fetchProductDetail() {
      getProductInfo({ id: this.$route.query.sonId }).then(res => {
        if (res.code === 1) {
          this.gzxhList = [];
          this.pictureList = [];
          this.detailsInfo = res.data;
          this.productList = res.data.glzxq;

          this.pictureList = res.data.full_image
            .split(",")
            .concat(res.data.full_images.split(","));
          let json = JSON.parse(res.data[`${this.currentLang.prefix}gzxh_json`]);
          for (var i in json) {
            this.gzxhList.push({ title: i, value: json[i] });
          }
        }
        else {
          this.$message({
            type: 'error',
            message: res.msg || '获取产品信息失败！'
          });
        }
      })
    },

    changePicture(index) {
      this.chooseIndex = index;
    },
    changeTab(num) {
      if (num === 1) {
        this.productList = this.detailsInfo.glzxq;
      } else {
        this.productList = this.detailsInfo.glgxf;
      }
      this.glChoose = num;
    },
    downloadPDF() {
      // 要下载的文件路径
      var fileUrl = "https://miniapp.kelkflow.com/" + this.detailsInfo.files[0].url;
      // 创建一个隐藏的<a>元素，用于下载文件
      var a = document.createElement("a");
      a.href = fileUrl;
      a.download = this.detailsInfo.files_name; // 可以自定义下载文件的名称
      a.style.display = "none";
      a.target = "_blank";
      // 将<a>元素添加到页面上
      document.body.appendChild(a);
      // 触发点击事件，开始下载
      a.click();
      // 下载完成后，移除<a>元素
      document.body.removeChild(a);
    },
    changeProduct(item){
      // this.$router.push('/prod_details')
      this.$router.push({ path: "/prod_details", query: { id: item.cate_id,sonId:item.id } });
    }
  },
};
</script>
<style scoped lang="scss">
.product_details {
  border-top: 1px solid #e3e3e3;

  .product_name {
    margin-top: 40px;
    font-size: 30px;
    text-align: center;
  }

  .product_content {
    width: 1200px;
    margin: 30px auto 0;
    font-size: 18px;
    font-size: 20px;
    color: #555;
    line-height: 1.8;
  }

  .product_img {
    width: 1200px;
    margin: 50px auto 0;
    display: flex;

    // align-items: center;
    // justify-content: center;
    .product_small_img_wrap {
      height: 420px;
      overflow-y: auto;
      overflow-x: hidden;

      .product_small_img {
        width: 50px;
        height: 50px;
        border: 2px solid lightgray;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        padding: 5px;
        border-radius: 5px;

        img {
          width: 50px;
          height: 50px;
          object-fit: contain;
        }
      }

      .chooseImg {
        border: 2px solid #003359;
      }
    }

    //     .product_small_img_wrap::-webkit-scrollbar {
    //         display: none;
    // }
    .product_big_img {
      width: auto;
      width: 600px;
      max-width: 800px;
      height: fit-content;
      height: 600px;
      margin-left: 330px;
      object-fit: contain;
    }
  }

  .ggxh_wrap {
    width: 1200px;
    margin: 50px auto 0;

    .ggxh_name {
      width: 100%;
      height: auto;
      padding: 15px 0;
      text-align: center;
      background: #003359;
      color: #fff;
      font-size: 28px;
    }

    .ggxh_list {
      display: flex;
      border-bottom: 1px solid #545454;
      font-size: 20px;

      .left_wrap {
        width: calc(30% - 80px);
        padding: 15px 40px;
        background: #dcdcdc;
        color: #555;
      }

      .right_wrap {
        width: calc(70% - 100px);
        padding: 15px 50px;
        background: #ededed;
        color: #555;
      }
    }

    .ggxh_list:last-child {
      border-bottom: 0;
    }

    .zh_list {
      display: flex;
      border-bottom: 1px solid #e1e1e1;

      .zh_left {
        box-sizing: border-box;
        width: 30%;
        color: #003359;
        font-size: 20px;
        padding: 25px 0;
        padding-left: 40px;
      }

      .zh_right {
        width: 70%;
        padding: 25px 0;
        font-size: 18px;
        font-size: 20px;
        color: #555;
        line-height: 1.8;
      }

      .pdf_wrap {
        display: flex;
        align-items: center;

        img {
          width: 50px;
          height: auto;
        }

        span {
          margin-left: 10px;
          color: #003359;
          color: #555;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }

  .ggxh_wrap2 {
    width: 1200px;
    margin: 50px auto;

    // display: flex;
    .ggxh_name_wrap {
      width: 100%;
      border-bottom: 1px solid #626262;
      display: flex;

      span {
        width: 50%;
        padding: 15px 0;
        text-align: center;
        font-size: 28px;
        display: block;
        cursor: pointer;
      }

      .ggxh_glzxq {
        color: #fff;
        background: #003359;
      }

      .ggxh_glgxf {
        color: #333;
        background: #f5f5f5;
      }
    }

    .ggxh_name_title {
      font-size: 20px;
      color: #555;
      padding: 20px 0;
    }
    /deep/ .el-collapse {
      border: none;
    }
    /deep/ .el-collapse-item {
      margin-bottom: 5px;
    }
    /deep/ .el-collapse-item__header {
      background: #ededed;
      font-size: 20px;
      color: #555;
      padding: 0 20px;

      span {
        width: 8px;
        height: 8px;
        background: #a8a8a8;
        border-radius: 50%;
        margin-right: 20px;
        // margin: 0 20px;
      }
    }
    /deep/ .el-collapse-item__wrap {
      border: none;
    }
    .product_detsils {
      display: flex;
      justify-content: space-between;
      .product_left_details {
        width: calc(100% - 345px);
        padding: 0 45px 0 0;
        .product_info {
          font-size: 18px;
          color: #777;
          line-height: 1.8;
        }
      }

      .product_left_details_title {
        color: #003359;
        font-weight: 500;
        font-size: 20px;
        margin-top: 20px;
        display: block;
                    
      }
      .product_right_img {
        width: 300px;
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 2px solid #f0f0f0;
        margin-top: 10px;
        position: relative;
        img {
          width: 100%;
          width: auto;
          height: 100%;
        }
        .dynamic_btn {
          width: 45px;
          height: 45px;
          background: #e8363e;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 35px;
          margin: 40px 0 0 0;
          cursor: pointer;
          position: absolute;
          bottom: 0;
          right: 0;
          .more_btn {
            width: 30px;
            height: auto;
          }
        }
      }
    }
  }
}


</style>


<style>
.product_info p,
.product_info p span {
  text-wrap-mode: wrap!important;
}

.ggxh_list_wrap .el-collapse-item__arrow.el-icon-arrow-right {
  transform: rotate(90deg);
}

.ggxh_list_wrap .el-collapse-item__arrow.el-icon-arrow-right.is-active {
  transform: rotate(-90deg);
}
</style>


// WEBPACK FOOTER //
// src/pages/home/home_product_center/productDetails.vue